interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm font-medium transition-colors cursor-pointer ${
              p === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${i}`} className="px-1 text-foreground-400">
            ...
          </span>
        ),
      )}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}